require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-phil-wilt.json") })
        }
      }, "path---blog-author-phil-wilt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-phil-wilt!./.cache/json/blog-author-phil-wilt.json
// module id = 693
// module chunks = 231608221292675